module.exports = __webpack_public_path__ + "images/accents/accent-box-engage-cba1856abc0bdd7529257c8013723511.webp";